import { routes } from '@/constant/routes.const';
import { ICON_CS_WHITE } from '@repo/assets';
import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import styled from 'styled-components';

type Props = {
  children: React.ReactNode;
};

const Layout = ({ children }: Props) => {
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    if (location.pathname === '/') {
      localStorage.clear();
      sessionStorage.clear();
    }
  }, []);

  if (location.pathname.includes('/inquiry')) {
    return <>{children}</>;
  }

  return (
    <>
      {children}
      <InquiryButton
        type='button'
        $isSignInPage={location.pathname === '/'}
        onClick={() => {
          sessionStorage.setItem('inquiry-endpoint', window.location.pathname);
          history.push(routes.inquiryFaq);
        }}
      >
        <img src={ICON_CS_WHITE} alt='inquiry' width={24} />
      </InquiryButton>
    </>
  );
};
export default Layout;

const InquiryButton = styled.button<{ $isSignInPage?: boolean }>`
  position: fixed;
  bottom: ${({ $isSignInPage }) => ($isSignInPage ? '90px' : '30px')};
  right: 20px;
  padding: 12px;
  background-color: #246cf6;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  box-shadow: 0 0 12px #00000060;
  z-index: 100;
`;
